import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "spectrum-web-component"
    }}>{`Spectrum Web Component`}</h1>
    <p><strong parentName="p">{`Since UXP v7.0`}</strong></p>
    <p>{`To understand Spectrum Web Components (popularly known as SWC), you must first familiarize yourself with`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.mozilla.org/en-US/docs/Web/Web_Components"
        }}>{`Web components`}</a>{`: HTML5 Web technology that lets you define custom HTML tags.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://spectrum.adobe.com/"
        }}>{`Spectrum`}</a>{`: An open-source design language and guidelines provided by Adobe.`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "https://opensource.adobe.com/spectrum-web-components/"
      }}>{`Spectrum Web Components`}</a>{` are open-source Adobe Spectrum-styled Web Components. UXP v7.0 introduces the support for Web Components and Spectrum Web Components (SWC).`}</p>
    <h2 {...{
      "id": "getting-started"
    }}>{`Getting started`}</h2>
    <p><strong parentName="p">{`Step 1`}</strong>{`: Enable SWC in manifest.json`}</p>
    <ul>
      <li parentName="ul">{`Use `}<inlineCode parentName="li">{`manifestVersion`}</inlineCode>{` version 5 or above`}</li>
      <li parentName="ul">{`Enable the `}<inlineCode parentName="li">{`enableSWCSupport`}</inlineCode>{` feature flag`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`"manifestVersion": 5,
 "host": [
   {
     "app": "PS",
     "minVersion": "24.4"
   }
 ],
 "featureFlags": {
   "enableSWCSupport": true
 }
`}</code></pre>
    <p><strong parentName="p">{`Step 2`}</strong>{`: Install the component. For example,`}</p>
    <pre><code parentName="pre" {...{}}>{`npm install @swc-uxp-wrappers/button
`}</code></pre>
    <p><strong parentName="p">{`Step 3`}</strong>{`: Import the component`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import '@swc-uxp-wrappers/button/sp-button.js';
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<sp-button variant="primary">I'm a button</sp-button>
`}</code></pre>
    <h2 {...{
      "id": "sample-plugin"
    }}>{`Sample plugin`}</h2>
    <p>{`The following resources are available for you to get started quickly`}</p>
    <h3 {...{
      "id": "command-line-templates"
    }}>{`Command line Templates`}</h3>
    <p>{`Use command-line tools (starter templates) for setting up a new UXP-based React/Vanilla app with SWC bundling. It helps you quickly scaffold a project optimized for building UXP plugins using SWC.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.npmjs.com/package/@swc-uxp-wrappers/create-swc-uxp-app"
        }}>{`Vanilla starter template`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.npmjs.com/package/@swc-uxp-wrappers/create-swc-uxp-react-app"
        }}>{`React starter template`}</a></li>
    </ul>
    <h3 {...{
      "id": "photoshop"
    }}>{`Photoshop`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/AdobeDocs/uxp-photoshop-plugin-samples/tree/main/swc-uxp-starter"
        }}>{`Photoshop SWC starter plugin`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/AdobeDocs/uxp-photoshop-plugin-samples/tree/main/swc-uxp-react-starter"
        }}>{`Photoshop React-based SWC starter plugin`}</a>{` (since UXP v7.3).`}</li>
    </ul>
    <h3 {...{
      "id": "indesign"
    }}>{`InDesign`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/AdobeDocs/uxp-indesign-samples/tree/main/plugins/swc-uxp-starter"
        }}>{`InDesign SWC starter plugin`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/AdobeDocs/uxp-indesign-samples/tree/main/plugins/swc-uxp-react-starter"
        }}>{`InDesign React-based SWC starter plugin`}</a>{` (since UXP v7.3).`}</li>
    </ul>
    <p>{`Make sure you follow the `}<inlineCode parentName="p">{`README`}</inlineCode>{` of the above `}<inlineCode parentName="p">{`plugins`}</inlineCode>{`.`}</p>
    <h2 {...{
      "id": "list-of-supported-swc"
    }}>{`List of supported SWC`}</h2>
    <p>{`Refer to the `}<a parentName="p" {...{
        "href": "https://github.com/adobe/swc-uxp-wrappers/tree/main?tab=readme-ov-file#spectrum-web-components-uxp-wrappers"
      }}>{`Github page`}</a>{` for the list of the components and their variants.
`}<strong parentName="p">{`Note`}</strong>{` With UXP v8.0.0, all the SWC components in UXP are locked to version 0.37.0.
`}<strong parentName="p">{`Note`}</strong>{` Apart from the components specific known issues, `}<inlineCode parentName="p">{`RTL`}</inlineCode>{` direction parameter does not work with `}<inlineCode parentName="p">{`sp-theme`}</inlineCode>{` across components.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      